export type FontSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
export const spacingSizes = [
  'px', 0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 72, 80, 96
];

export type StylesBaseConfig = {
  paddingClasses: {
    [key: string]: string[]
  };
  marginClasses: {
    [key: string]: string[]
  };
  spacing: {
    [key in typeof spacingSizes[number]]: string | number;
  };
  fontSizes: {
    [key in FontSize]: {
      fontSize: string | number;
      lineHeight: string | number;
      letterSpacing: string | number;
    }
  };
  fontFamilies: {
    serif: string[];
    sansSerif: string[];
    mono: string[];
  };
};

export const stylesBaseConfig: StylesBaseConfig = {
  paddingClasses: {
    p: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
    pt: ['paddingTop'],
    pr: ['paddingRight'],
    pb: ['paddingBottom'],
    pl: ['paddingLeft'],
    px: ['paddingLeft', 'paddingRight'],
    py: ['paddingTop', 'paddingBottom'],
    ps: ['paddingInlineStart'],
    pe: ['paddingInlineEnd'],
  },
  marginClasses: {
    m: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'],
    mt: ['marginTop'],
    mr: ['marginRight'],
    mb: ['marginBottom'],
    ml: ['marginLeft'],
    mx: ['marginLeft', 'marginRight'],
    my: ['marginTop', 'marginBottom'],
    ms: ['marginInlineStart'],
    me: ['marginInlineEnd'],
  },
  spacing: {
    px: '1px',
    0: '0px',
    0.5: '2px',
    1: '4px',
    1.5: '6px',
    2: '8px',
    2.5: '10px',
    3: '12px',
    3.5: '14px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
    10: '40px',
    11: '44px',
    12: '48px',
    14: '56px',
    16: '64px',
    20: '80px',
    24: '96px',
    28: '112px',
    32: '128px',
    36: '144px',
    40: '160px',
    44: '176px',
    48: '192px',
    52: '208px',
    56: '224px',
    60: '240px',
    64: '256px',
    72: '288px',
    80: '320px',
    96: '384px',
  },
  fontSizes: {
    xs: {
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.24px',
    },
    sm: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.28px',
    },
    base: {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.32px',
    },
    lg: {
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0.36px',
    },
    xl: {
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '0.4px',
    },
    '2xl': {
      fontSize: '24px',
      lineHeight: '32px',
      letterSpacing: '0.48px',
    },
    '3xl': {
      fontSize: '28px',
      lineHeight: '36px',
      letterSpacing: '0.56px',
    },
    '4xl': {
      fontSize: '32px',
      lineHeight: '40px',
      letterSpacing: '0.64px',
    },
  },
  fontFamilies: {
    serif: ['Lora', 'ui-serif', 'Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'],
    sansSerif: [
      'Poppins',
      'ui-sans-serif',
      'system-ui',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      '"Noto Color Emoji"',
      'sans-serif'
    ],
    mono: [
      'ui-monospace',
      'SFMono-Regular',
      'Menlo',
      'Monaco',
      'Consolas',
      '"Liberation Mono"',
      '"Courier New"',
      'monospace',
    ],
  },
};
